import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { DropdownOption } from '@shared/models/dropdown.model';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
})
export class DropdownComponent implements OnInit {
  @Input()
  public options: DropdownOption<unknown>[] = [];
  @Input()
  public control!: UntypedFormControl;
  @Input()
  public hasNoneOption = true;
  @Input()
  public class = '';
  @Input()
  public styleClass = '';
  /**
   * Class put on the options panel. A dropdown sitting near the right edge needs
   * `dropdown-panel-right` so the panel opens leftwards; the panel is wider than
   * its trigger and would otherwise extend past the viewport and scroll the page
   * sideways. Empty by default so existing screens are untouched.
   */
  @Input()
  public panelStyleClass = '';

  ngOnInit(): void {
    if (this.hasNoneOption && !this.control.hasValidator(Validators.required) && !this.options.some(o => o.value === '')) {
      this.addNoneOption();
    }
  }

  private addNoneOption(): void {
    this.options = [
      ...this.options,
      {
        value: '',
        label: '--',
      },
    ];
  }
}
